import { render, staticRenderFns } from "./FixAssetApiSearch.vue?vue&type=template&id=71f4e3a5&"
import script from "./FixAssetApiSearch.vue?vue&type=script&lang=ts&"
export * from "./FixAssetApiSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports